var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardPlayerVolumeBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.716,
    height: 17.952,
    viewBox: "0 0 20.716 17.952",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1142",
    "data-name": "Group 1142",
    transform: "translate(0.186 0.185)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1143",
    "data-name": "Group 1143",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_860",
    "data-name": "Path 860",
    d: "M3.885,8.675C2.023,8.675.5,9.724.5,11.005v2.011c0,1.282,1.523,2.33,3.385,2.33Z",
    transform: "translate(-0.186 -3.221)",
    fill: "none",
    stroke: "#a8a8a8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_861",
    "data-name": "Path 861",
    d: "M5.883,5.64,13.567.5V17.452l-7.684-5.14",
    transform: "translate(-2.184 -0.186)",
    fill: "none",
    stroke: "#a8a8a8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_862",
    "data-name": "Path 862",
    d: "M22.339,16.1a3.908,3.908,0,0,0,0-7.52",
    transform: "translate(-8.293 -3.186)",
    fill: "none",
    stroke: "#a8a8a8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_863",
    "data-name": "Path 863",
    d: "M25.891,17.21a6.381,6.381,0,0,0,3.751-5.949,6.381,6.381,0,0,0-3.751-5.949",
    transform: "translate(-9.612 -1.972)",
    fill: "none",
    stroke: "#a8a8a8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardPlayerVolumeBtn);
export default __webpack_public_path__ + "static/media/dashboard-player-volume-btn.caa452e1.svg";
export { ForwardRef as ReactComponent };